export default "__VITE_ASSET__BoWfzmSc__"